import { useTranslation } from 'react-i18next';
import { createPortal } from 'react-dom';
import { LogIn, Clock } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router';

import { Button } from '@/shared/components/ui/button';

interface Props {
  open: boolean;
}

export function SessionExpiredModal({ open }: Props): JSX.Element | null {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  if (!open) return null;

  const handleLogin = (): void => {
    const returnTo = encodeURIComponent(`${location.pathname}${location.search}`);
    navigate(`/login?returnTo=${returnTo}`, { replace: true });
  };

  return createPortal(
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div
        className="mx-4 w-full max-w-sm rounded-xl border bg-background p-6 shadow-2xl"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="session-expired-title"
        aria-describedby="session-expired-desc"
      >
        <div className="mb-4 flex size-12 items-center justify-center rounded-full bg-warning/10">
          <Clock className="size-6 text-warning-text" />
        </div>
        <h2
          id="session-expired-title"
          className="mb-2 text-lg font-semibold tracking-tight"
        >
          {t('auth.session.expiredTitle')}
        </h2>
        <p
          id="session-expired-desc"
          className="mb-6 text-sm text-muted-foreground"
        >
          {t('auth.session.expiredMessage')}
        </p>
        <Button className="w-full" onClick={handleLogin}>
          <LogIn className="size-4" />
          {t('auth.session.loginAgain')}
        </Button>
      </div>
    </div>,
    document.body,
  );
}
